import { render, staticRenderFns } from "./CompanyNewsArticle1.vue?vue&type=template&id=b1879afa&scoped=true"
import script from "./CompanyNewsArticle1.vue?vue&type=script&lang=js"
export * from "./CompanyNewsArticle1.vue?vue&type=script&lang=js"
import style0 from "./CompanyNewsArticle1.vue?vue&type=style&index=0&id=b1879afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1879afa",
  null
  
)

export default component.exports